// extracted by mini-css-extract-plugin
export default {"box":"SimulatorInterface_box__GFX8p"};